import React from "react";
import { Typography } from "@mui/material";

const NoConversations = () => {
  return (
    <Typography
      id="noconversation"
      align="center"
      sx={{
        my: 8,
      }}
      color="secondary"
    >
      No conversations created yet. Create new to get started!
    </Typography>
  );
};

export default NoConversations;
